export default __webpack_public_path__ + "static/media/FinTech.f934ee47.svg";